/*
 * Sector 5 — letrero de "envío gratis" en vivo para la página de producto.
 * Mantiene el mensaje y la barra sincronizados con el total REAL del carrito:
 * al cargar la página y cada vez que el carrito se modifica (agregar producto).
 *
 * No cuenta el producto que se está viendo hasta que se agrega al carrito.
 *
 * El carrito (drawer) y la página del carrito NO usan este archivo: se
 * recalculan solos en Liquid porque Dawn re-renderiza esas secciones enteras.
 *
 * Umbral: mantener sincronizado con `s5_threshold` en
 * snippets/sector5-free-shipping-bar.liquid
 */
(function () {
  var THRESHOLD = 180000; // centavos = $1,800 MXN

  // Formatea centavos usando el `shop.money_format` del tema (ej. "$ {{amount}}").
  // Sin decimales cuando el monto es entero (imita `money_without_trailing_zeros`).
  function formatMoney(cents, format) {
    format = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    cents = Math.max(0, Math.round(cents));

    function commas(str) {
      return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    function apostrophes(str) {
      return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
    }
    function decimalComma(num) {
      // 1234567 (centavos) -> "1.234,56"
      var s = (num / 100).toFixed(2).replace('.', ',');
      return s.replace(/(\d)(?=(\d{3})+(?!\d),)/g, '$1.');
    }

    var noDecimals = cents % 100 === 0;

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':
          return noDecimals ? commas(String(cents / 100)) : commas((cents / 100).toFixed(2));
        case 'amount_no_decimals':
          return commas(String(Math.round(cents / 100)));
        case 'amount_with_comma_separator':
          return noDecimals
            ? decimalComma(cents).split(',')[0]
            : decimalComma(cents);
        case 'amount_no_decimals_with_comma_separator':
          return String(Math.round(cents / 100)).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        case 'amount_with_apostrophe_separator':
          return noDecimals ? apostrophes(String(cents / 100)) : apostrophes((cents / 100).toFixed(2));
        default:
          return commas(String(Math.round(cents / 100)));
      }
    });
  }

  function S5FreeShip(el) {
    this.el = el;
    this.cartTotal = parseInt(el.dataset.cartTotal || '0', 10) || 0;
    this.moneyFormat = el.dataset.moneyFormat || '${{amount}}';
    this.msgEl = el.querySelector('[data-s5-freeship-msg]');
    this.fillEl = el.querySelector('[data-s5-freeship-fill]');

    var self = this;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unCart = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        self.refreshCart();
      });
    }

    this.render();
  }

  S5FreeShip.prototype.refreshCart = function () {
    var self = this;
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          self.cartTotal = cart.total_price;
          self.render();
        }
      })
      .catch(function () {});
  };

  S5FreeShip.prototype.render = function () {
    var base = this.cartTotal;
    var remaining = THRESHOLD - base;
    var pct = Math.max(0, Math.min(100, (base / THRESHOLD) * 100));

    if (this.fillEl) this.fillEl.style.width = pct + '%';
    this.el.classList.toggle('s5-freeship--unlocked', remaining <= 0);

    if (this.msgEl) {
      this.msgEl.innerHTML = remaining <= 0
        ? '🎉 ¡Tu compra tiene <strong>envío gratis</strong>!'
        : 'Te faltan <strong>' + formatMoney(remaining, this.moneyFormat) + '</strong> para el <strong>envío gratis</strong>';
    }
  };

  function init(root) {
    (root || document).querySelectorAll('[data-s5-freeship-product]').forEach(function (el) {
      if (el.dataset.s5Init === '1') return;
      el.dataset.s5Init = '1';
      new S5FreeShip(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Al re-montarse <product-info> (listado combinado / cambio de variante con recarga parcial)
  document.addEventListener('product-info:loaded', function () { init(); });
})();
